import { ICON_TYPES } from '../constants';

export const ParkingIcon = (): JSX.Element => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M3.5 21H1.75V2.625C1.75 1.17775 2.92775 0 4.375 0H12.6875C16.3065 0 19.25 2.9435 19.25 6.5625C19.25 10.1815 16.3065 13.125 12.6875 13.125H3.5V21ZM3.5 11.375H12.6875C15.3414 11.375 17.5 9.2155 17.5 6.5625C17.5 3.9095 15.3414 1.75 12.6875 1.75H4.375C3.89287 1.75 3.5 2.142 3.5 2.625V11.375Z"
          fill="#43494F"
        />
      </g>
    </svg>
  );
};

ParkingIcon.iconType = ICON_TYPES.PARKING;
